import React from 'react'
import BaseIcon from 'react-icon-base'

import { EColors } from 'app/constants/colors'

type PropTypes = {
  [prop: string]: any
  pathProps?: Record<string, any>
}

const TrashIcon: React.FC<PropTypes> = ({ pathProps, ...props }) => {
  return (
    <BaseIcon width="12" height="16" viewBox="0 0 12 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.762 2.853V1.19H8.91L8.059.378H3.961l-.852.812H.24v1.663h11.523zM9.287 15.228c.449 0 .838-.165 1.168-.495.33-.33.495-.72.495-1.168v-9.9h-9.9v9.9c0 .449.165.838.495 1.168.33.33.72.495 1.168.495h6.574z"
        fill={EColors.MEDIUM_GREY}
        fillRule="nonzero"
        {...pathProps}
      />
    </BaseIcon>
  )
}

export default TrashIcon
